import React, { useState, useEffect } from 'react';
import { 
  Container, 
  Typography, 
  Grid, 
  Paper, 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  Button, 
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material';
import axios from 'axios';

function OrderSettings() {
  const [settings, setSettings] = useState({
    consolidation_frequency: 'weekly',
    consolidation_day: 'friday',
    consolidation_time: '17:00'
  });
  const [manualConsolidationOpen, setManualConsolidationOpen] = useState(false);
  const [consolidationResult, setConsolidationResult] = useState(null);

  const handleSettingsChange = (e) => {
    const { name, value } = e.target;
    setSettings(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSaveSettings = async () => {
    try {
      const response = await axios.post('/api/order-settings', settings);
      // Handle success
    } catch (error) {
      // Handle error
    }
  };

  const handleManualConsolidation = async () => {
    try {
      const response = await axios.post('/api/manual-consolidation');
      setConsolidationResult(response.data);
      setManualConsolidationOpen(true);
    } catch (error) {
      // Handle error
    }
  };

  return (
    <Container maxWidth="md">
      <Box 
        sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
          color: 'white', 
          padding: '20px', 
          borderRadius: '16px', 
          marginBottom: '30px' 
        }}
      >
        <Typography variant="h4" gutterBottom>
          Order Consolidation Settings
        </Typography>
      </Box>

      <Paper 
        elevation={6} 
        sx={{ 
          padding: '30px', 
          borderRadius: '16px',
          background: 'white',
          boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
        }}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <InputLabel>Consolidation Frequency</InputLabel>
              <Select
                name="consolidation_frequency"
                value={settings.consolidation_frequency}
                onChange={handleSettingsChange}
              >
                <MenuItem value="daily">Daily</MenuItem>
                <MenuItem value="weekly">Weekly</MenuItem>
                <MenuItem value="monthly">Monthly</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <InputLabel>Consolidation Day</InputLabel>
              <Select
                name="consolidation_day"
                value={settings.consolidation_day}
                onChange={handleSettingsChange}
              >
                {['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
                  .map(day => (
                    <MenuItem key={day.toLowerCase()} value={day.toLowerCase()}>
                      {day}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <InputLabel>Consolidation Time</InputLabel>
              <input
                type="time"
                name="consolidation_time"
                value={settings.consolidation_time}
                onChange={handleSettingsChange}
                style={{ 
                  padding: '10px', 
                  width: '100%', 
                  borderRadius: '8px', 
                  border: '1px solid #ccc' 
                }}
              />
            </FormControl>
          </Grid>
        </Grid>

        <Box 
          sx={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            marginTop: '30px' 
          }}
        >
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleSaveSettings}
            sx={{ 
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              padding: '12px 24px',
              borderRadius: '12px'
            }}
          >
            Save Settings
          </Button>

          <Button 
            variant="outlined" 
            color="secondary"
            onClick={handleManualConsolidation}
            sx={{ 
              borderColor: '#667eea',
              color: '#667eea',
              padding: '12px 24px',
              borderRadius: '12px'
            }}
          >
            Manual Consolidation
          </Button>
        </Box>
      </Paper>

      {/* Manual Consolidation Result Dialog */}
      <Dialog 
        open={manualConsolidationOpen} 
        onClose={() => setManualConsolidationOpen(false)}
      >
        <DialogTitle>Manual Consolidation Result</DialogTitle>
        <DialogContent>
          {consolidationResult && (
            <Typography>
              {consolidationResult.message}
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => setManualConsolidationOpen(false)} 
            color="primary"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}

export default OrderSettings;